module.exports = { tmpdir: function() { return "/tmp"; } };
